import comingSoon from "assets/png/comingSoon.png";

function ComingSoon() {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
      }}
    >
      <img
        style={{
          height: "100%",
          width: "100%",
        }}
        src={comingSoon}
        alt="comingsoon"
      />
    </div>
  );
}

export default ComingSoon;
